<template>
  <base-section-layout :title="sectionTitle" :icon="sectionIcon">
    <div v-if="attentionList.length" class="sub-block">
      <div class="sub-title">{{ attentionTitle }}</div>
      <div class="attention-list">
        <div
          v-for="(item, index) in attentionList"
          :key="index"
          class="attention-item"
        >
          {{ item }}
        </div>
      </div>
    </div>

    <div
      v-if="
        interviewData.interview_process &&
        interviewData.interview_process.length
      "
      class="sub-block"
    >
      <div class="sub-title">{{ processTitle }}</div>
      <div class="process-list">
        <div
          v-for="(item, index) in interviewData.interview_process"
          :key="index"
          class="process-item"
        >
          <div class="process-name">{{ index + 1 }}. {{ item.title }}</div>
          <div class="process-desc">{{ item.content }}</div>
        </div>
      </div>
    </div>
  </base-section-layout>
</template>

<script>
import BaseSectionLayout from './BaseSectionLayout.vue';

export default {
  name: 'SectionAttentionProcess',
  components: {
    BaseSectionLayout,
  },
  props: {
    interviewData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    sectionIcon() {
      return this.interviewData.need_interview > 0
        ? 'https://pbs-public.oss-cn-shenzhen.aliyuncs.com/static-visa/pdv-www/order/order-interview-notification/section-process.png'
        : 'https://pbs-public.oss-cn-shenzhen.aliyuncs.com/static-visa/pdv-www/order/order-interview-notification/section-attention.png';
    },
    typeText() {
      return this.interviewData && this.interviewData.need_interview > 0
        ? '面试'
        : '录指纹';
    },
    sectionTitle() {
      return `${this.typeText}注意事项与流程`;
    },
    attentionTitle() {
      return `${this.typeText}注意事项`;
    },
    processTitle() {
      return `${this.typeText}流程`;
    },
    attentionList() {
      const attention = this.interviewData.interview_attention;
      if (!attention) return [];
      if (Array.isArray(attention)) return attention;
      return String(attention)
        .split('\n')
        .filter((item) => item);
    },
  },
};
</script>

<style lang="less" scoped>
.sub-block {
  padding: 16px 0;
  border-bottom: 0.5px solid #e9eef2;

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
    border-bottom: 0;
  }

  .sub-title {
    margin-bottom: 8px;
    color: #333;
    font-size: 12px;
    font-weight: 500;
    line-height: 22px;
  }

  .attention-item {
    margin-bottom: 8px;
    color: #666;
    font-size: 12px;
    line-height: 21px;
    word-break: break-all;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .process-item {
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .process-name {
    color: #333;
    font-size: 12px;
    line-height: 21px;
  }

  .process-desc {
    margin-top: 2px;
    padding-left: 14px;
    color: #a6a6a6;
    font-size: 12px;
    line-height: 21px;
    word-break: break-all;
    white-space: pre-wrap;
  }
}
</style>
